import { useContext } from "react";
import { CouponContext } from "@contexts/CouponContext";

export const useCoupon = () => {
  const context = useContext(CouponContext);
  return context;
};
